import EmptyLayout from '@/layout/empty'
export default [
    {
        path: '/industry',
        redirect: '/information',
        component: EmptyLayout,
        children: [
            {
                path: 'information',
                name: 'IndustryInformation',
                component: () => import(/* webpackChunkName: 'root' */ '@/views/industryInfo/IndustryInformation.vue'),
                meta: {
                    title: '行业信息'
                }
            },
            {
                path: 'detail',
                name: 'industryDeatil',
                component: () => import(/* webpackChunkName: 'root' */ '@/views/industryInfo/industryDetail.vue'),
                meta: {
                    title: '行业信息-详情'
                }
            },
            {
                path: 'detail',
                name: 'caseDeatil',
                component: () => import(/* webpackChunkName: 'root' */ '@/views/industryInfo/industryDetail.vue'),
                meta: {
                    title: '合作案例-详情'
                }
            }
        ]
    }
]
